import { ACCESS_TOKEN_KEY } from 'sr/constants/common'
import { getCookieValue } from 'sr/utils/helper'

export type AuditAction =
  | 'VIEW_PAGE'
  | 'VIEW_CLEANER_DETAILS'
  | 'VIEW_COMPANY_DETAILS'
  | 'VIEW_JOB_DETAILS'
  | 'VIEW_APPLICATION_DETAILS'
  | 'VIEW_LOCATION_DETAILS'
  | 'VIEW_WORKORDER_DETAILS'
  | 'UPDATE_CLEANER'
  | 'UPDATE_COMPANY'
  | 'UPDATE_JOB'
  | 'UPDATE_APPLICATION'
  | 'TOGGLE_INTERNAL_CLEANER'
  | 'TOGGLE_INTERNAL_COMPANY'
  | 'EXPORT_CLEANERS'
  | 'EXPORT_COMPANIES'
  | 'EXPORT_JOBS'
  | 'EXPORT_APPLICATIONS'
  | 'EXPORT_LOCATIONS'
  | 'LOGIN_SUCCESS'
  | 'LOGOUT_SUCCESS'
  | 'CHANGE_PASSWORD'
  | 'CREATE_ADMIN_USER'
  | 'UPDATE_ADMIN_USER'
  | 'DEACTIVATE_ADMIN_USER'
  | 'ACTIVATE_ADMIN_USER'
  | 'RESET_ADMIN_PASSWORD'
  | 'WRITE_REQUEST'
  | 'WRITE_BLOCKED_READONLY'
  | 'PURGE_AUDIT_LOGS'

export type EntityType = 
  | 'cleaner' 
  | 'company' 
  | 'job' 
  | 'application' 
  | 'company_location'
  | 'workorder'
  | 'customer'
  | 'user' 
  | 'admin_user'
  | 'page'
  | 'system'

interface AdminAuditEvent {
  action: AuditAction
  entityType?: EntityType
  entityId?: string
  entityName?: string
  changes?: Record<string, unknown>
  metadata?: Record<string, unknown>
  status?: 'success' | 'failed' | 'partial'
  errorMessage?: string | null
}

export const logAdminEvent = async (event: AdminAuditEvent) => {
  try {
    const accessToken = getCookieValue(ACCESS_TOKEN_KEY)
    if (!accessToken) {
      return
    }

    await fetch(`${process.env.REACT_APP_API_URL}/admin/audit/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        eventType: event.action, // Map 'action' to 'eventType' for backend
        entityType: event.entityType || 'system', // Default to 'system' instead of 'other'
        entityId: event.entityId,
        entityName: event.entityName,
        changes: event.changes,
        metadata: event.metadata,
        status: event.status || 'success',
        errorMessage: event.errorMessage,
      }),
    })
  } catch (error) {
    // Silent fail to avoid disrupting user workflow
  }
}
